// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1Ux-8","footer":"ModalInfo_footer__239_3"};